/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Header } from "./Header";
import { TemplateHeaderCellModel } from "./TemplateHeaderCellModel";
import { markType } from "igniteui-react-core";
import { TemplateHeaderCellUpdatingEventArgs } from "./TemplateHeaderCellUpdatingEventArgs";
/**
 * @hidden
 */
var TemplateHeader = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateHeader, _super);
    function TemplateHeader() {
        var _this = _super.call(this) || this;
        _this.cellUpdating = null;
        return _this;
    }
    TemplateHeader.prototype.l = function (a) {
        return new TemplateHeaderCellModel();
    };
    TemplateHeader.prototype.cm = function (a, b, c) {
        var d = "template-header-" + a.ax.toString();
        return d;
    };
    TemplateHeader.prototype.cy = function (a, b, c, d) {
        _super.prototype.cy.call(this, a, b, c, d);
        var e = a;
        var f = b.a0(a.k);
        e.kh = f.hh;
        e.m = f.e6;
        e.kk = f.f3;
    };
    TemplateHeader.prototype.fd = function (a, b) {
        if (this.cellUpdating != null) {
            this.cellUpdating(this, ((function () {
                var $ret = new TemplateHeaderCellUpdatingEventArgs();
                $ret.cellInfo = a;
                $ret.content = b;
                return $ret;
            })()));
        }
    };
    TemplateHeader.$t = markType(TemplateHeader, 'TemplateHeader', Header.$);
    return TemplateHeader;
}(Header));
export { TemplateHeader };
//# sourceMappingURL=TemplateHeader.js.map
